import { type Hash } from 'history';
import { matchPath } from 'react-router';

const changePasswordMatcher = (hash: Hash) => {
  const path = hash.substring(1);
  const [pathname, search] = path.split('?');
  const match = matchPath('/change-password/:userId/:token', pathname);
  if (!match) return null;
  const email = new URLSearchParams(search).get('email');
  return {
    ...match.params,
    email: email ? decodeURIComponent(email) : undefined,
  };
};

export default changePasswordMatcher;
